export default {
  home: {
    indicatePreferred: 'Indicate your preferred pick-up location',
    searchAddress: 'Search the address and/or move the pin to your preferred pick-up location',
    setLater: 'Set later',
  },
  kvkk: {
    approveDocument: 'I have read and agree',
  },
  hideCompleted: 'Hide Completed',
  wallet: {
    title: 'My Wallet',
    balance: 'Balance',
    addMoney: 'Add Money',
    transactions: 'Transactions',
    noTransactions: 'No transactions yet',
    topUpTitle: 'Top up to Wallet',
    enterAmount: 'Enter the amount to top up.',
    continueSecurePayment: 'Then continue to secure payment with your preferred method.',
    total: 'Total to be charged',
    totalAfterFee: 'Total to be charged after payment provider fee added',
    currentBalance: 'Current Balance',
    cancel: 'Cancel',
    continueToPayment: 'Continue to Payment',
    back: 'Back',
    pay: 'Pay',
    processing: 'Processing...',
    paymentSuccessTitle: 'Payment Successful',
    paymentSuccessMessage: 'Your wallet has been topped up successfully.',
    paymentFailedTitle: 'Payment Failed',
    paymentFailedMessage: 'Something went wrong with your payment. Please try again.',
    done: 'Done',
    tryAgain: 'Try Again',
    serviceFeeCharged: '{amount} Service fee charged.',
    monthlyPass: 'Monthly Pass',
    unlimitedRides: 'Unlimited rides on all routes',
    pricePerMonth: '{price}/ month',
    buy: 'Buy',
    buyMonthlyPass: 'Buy Monthly Pass',
    validUntilEndOfMonth: 'Valid until the end of the current calendar month.',
    processingFee: 'Processing fee',
    totalToBePaid: 'Total to be paid',
    monthlyPassActive: 'Monthly Pass active',
    expiresInDays: 'Expires in {count} day | Expires in {count} days',
    monthlyPassActivated: 'Monthly Pass activated',
    walletTopUp: 'Wallet Top-up',
    walletTopUpByAdmin: 'Wallet Top-up by Admin',
    paymentFromMethod: '{amount} from {method}',
    paymentFromWallet: '{amount} from Balance',
    paymentSourceList: '{first}, {second}',
    monthListSeparator: ', ',
    monthlyPassForMonth: '{month} Pass',
    monthlyPassForMonths: '{months} Passes',
    serviceFeeChargedWithAmount: '{amount} + {fee} Service fee charged',
    passSuccessMessage: 'Your Monthly Pass is now active.',
    coveredByMonthlyPass: 'Covered by monthly pass',
    selectMonthDescription: "Select month(s) for which you'd like to buy a pass",
    noAvailablePasses: 'No passes are available to buy right now.',
    passValidUntil: 'Valid until {date}',
    passValidRange: 'Valid {date}',
    validFromTo: 'Valid from {from} to {to}.',
    passExpiresOn: 'Expires on {date}',
    totalAmount: 'Total Amount',
    walletBalanceLabel: 'Wallet Balance',
    useWalletBalance: 'Use wallet balance',
    remaining: 'Remaining',
    buyOtherPass: 'Buy other pass',
    confirm: {
      title: 'Confirm Payment',
      message:
        'Would you like to use your {walletAmount} wallet balance and pay the remaining {remainingAmount} with your credit card for the {totalAmount} monthly pass?',
      messageWalletOnly:
        'Would you like to use your {walletAmount} wallet balance to pay for the {totalAmount} monthly pass?',
      messageCardOnly: 'Would you like to pay {totalAmount} with your credit card for the monthly pass?',
      confirmButton: 'Confirm and Pay',
    },
    errors: {
      passAlreadyExists: 'You already have a pass for the selected month.',
      purchaseInProgress: 'A previous purchase is still being processed. Please try again in a few seconds.',
      purchaseCompleted: 'Your purchase is complete and will be active shortly.',
      insufficientBalance: 'Your wallet balance is not enough for this purchase.',
      notEnabled: 'Monthly Pass is not available for your company.',
      invalidData: 'The selected months are invalid. Please review your selection.',
    },
  },
  routeSearch: {
    title: 'Search Routes',
    filters: {
      suggested: 'Suggested',
      allRoutes: 'All Routes',
      commute: 'Fixed',
      loop: 'Loop',
      overtime: 'Overtime',
      nearDemand: 'Near Demand',
    },
    toDestination: 'to',
    dynamicBadge: 'Dynamic',
    reservationsCloseIn: 'Reservations close in',
    showZonesInfo: 'Show zones',
    hideZonesInfo: 'Hide zones',
    hideRoutes: 'Hide Routes',
    showRoutes: 'Show Routes',
    routesThroughStation: 'Routes through {station}',
    routesPassingHere: 'Routes passing here',
    noRoutesAtStop: 'No routes pass through this stop.',
    emptyState:
      'No routes pass by this location on the selected date. Pan the map to another area or try another date.',
    campus: 'Campus',
    home: 'Home',
    myLocation: 'My Location',
    addHomeAddressMessage: 'Add your home address to find routes close to you.',
    addNow: 'Add Now',
    later: 'Later',
    locationPermissionMessage: 'Please allow location access in your browser settings to see routes near you.',
    ok: 'OK',
    routePinned: 'Route Pinned',
    routePinnedMessage:
      'Route pinned for easy access. To receive approaching and arrival notifications, please make a reservation for this route.',
    nearDemandGroupPinned: 'Near Demand Group Pinned',
    nearDemandGroupPinnedMessage: 'Near demand group pinned for easy access.',
    requestFailed: 'Request Failed',
    cannotUnpin: 'This route cannot be unpinned.',
    genericError: 'An error occurred. Please try again.',
    selectPickupInside: 'Select pickup inside {zone}',
    selectDropoffInside: 'Select dropoff inside {zone}, {time}',
    tbd: 'TBD',
    waitlist: 'Waitlist',
    waitlistMessage: 'You have been added to the waitlist. Your position: {order}.',
    demandSuccess: 'Your demand has been submitted successfully.',
    multiDemandSuccess: 'Your multi-day demand has been submitted successfully.',
    reservationSuccess: 'Your reservation has been created successfully.',
    subscribeSuccess: 'You have been subscribed successfully.',
    actionSuccess: 'Action completed successfully.',
    // A subscription is per departure time and repeats on every day the
    // route runs; it has no date (VSER-15349).
    pinSheet: {
      pinRoute: 'Pin this route',
      notifications: 'Get approaching and arrival notifications',
      thisTripOnly: 'Only the {time} trip',
      thisTripOnlyNoTime: 'Only this departure time',
      allTrips: 'All departure times',
      hint: 'The selected trips are added to your trips on every day the route runs.',
      cancel: 'Cancel',
      save: 'Save',
    },
  },
  bringingBike: 'Bringing a bike',
  bikes: 'Bikes',
  usingWheelchair: 'Using a wheelchair',
  wheelchairs: 'Wheelchairs',
  bikeCapacityFull: 'Bike capacity is full',
  remainingBikeCapacity: 'Remaining bike capacity',
  wheelchairCapacityFull: 'Wheelchair capacity is full',
  routeDetail: {
    activeOn: 'Active on',
    vehicleDriver: 'Vehicle, Driver',
    weekdays: 'Weekdays',
    everyDay: 'Every day',
    days: {
      mon: 'Mon',
      tue: 'Tue',
      wed: 'Wed',
      thu: 'Thu',
      fri: 'Fri',
      sat: 'Sat',
      sun: 'Sun',
    },
    departFrom: 'Depart from',
    arriveAt: 'Arrive at',
    departureTime: 'Departure Time',
    etd: 'ETD',
    eta: 'ETA',
    tbd: 'TBD',
    addressPlaceholder: 'Type address or select location on the map',
    addressOutsideArea: 'The address must be inside the highlighted area',
    serviceAreaBanner:
      'Click inside the service area highlighted in green to place your location pin or select a Park &Ride. Alternatively search for an address below.',
    multipleDayReservation: 'Multiple-Day Reservation',
    fromUntil: 'From-Until',
    daysToUseShuttle: 'Days on which I will use the shuttle:',
    numberOfRiders: 'Number of Riders',
    riderCountLimitedByCapacity: 'Rider count is limited by the route capacity',
    driver: 'Driver',
    vehicle: 'Vehicle',
    noReservationsRequired: 'No reservations required',
    subscribe: 'Subscribe',
    waitlistOpen: 'Waitlist open',
    joinWaitlist: 'Join Waitlist',
    boardingFarePerTrip: 'Boarding Fare per Trip',
    organizationBoardingFare: 'Organization Boarding Fare',
    guestBoardingFare: 'Guest Boarding Fare',
    freeWithMonthlyPass: '(Free with Monthly Pass)',
    remainingBikeCapacity: 'Remaining Bike Capacity',
    reservationsCloseIn: 'Reservations close in',
    seatsRemaining: 'Seats Remaining',
    reserve: 'Reserve',
    reservationsOpenOn: 'Reservations open on {date}',
    reservationWindowClosed: 'Reservation window has closed',
    durationHoursMinutes: '{hours}h {minutes} min',
    durationMinutes: '{minutes} min',
  },
};
